<template>
  <div>
    <button class="icon-button" title="Вопрос по лоту" @click="openQuestionModal">
      <img
        src="@/assets/img/icons/question.svg"
        alt="Вопрос по лоту"
      />
    </button>

    <modal-window :show="showQuestionModal" @close="onModalClose">
      <template v-slot:popup-title>
        Вопрос по лоту №: {{ item.contractNumber }} {{ item.car.name }}
      </template>
      <template v-slot:popup-content>
        <div class="d-flex flex-column">
            <template v-if="!isQuestionSent">
            <div class="form-field question-textarea">
                <textarea
                v-model="question"
                class="input"
                placeholder="Введите вопрос"
                rows="6"
                :maxlength="1000"
                ></textarea>
                <span class="question-length">{{ question.length }}/1000</span>
                <p v-if="questionError" class="form-error">
                {{ questionError }}
                </p>
            </div>
            <div class="d-flex justify-content-center">
                <div
                  class="text-center position-relative"
                  :class="{ '--loading': isQuestionSaving }"
                >
                  <button class="button" @click="saveQuestion">Отправить</button>
                  <Preloader v-if="isQuestionSaving" forButton invert />
                </div>

                <button
                type="button"
                class="button button--transparent ms-4"
                @click="onModalClose"
                >
                Отменить
                </button>
            </div>
            </template>
            <template v-else>
                <div>
                    <p class="text-center">Вопрос по&nbsp;лоту успешно отправлен.<br /> Мы свяжемся с&nbsp;вами по&nbsp;электронной почте или по&nbsp;телефону.</p>
                    <div class="d-flex justify-content-center">
                
                <button
                  type="button"
                  class="button button--transparent mx-auto"
                  @click="onModalClose"
                >
                  Закрыть
                </button>
            </div>
                </div>
            </template>
        </div>
      </template>
    </modal-window>
  </div>
</template>

<script setup lang="ts">
import ModalWindow from "~/components/page/modalWindow.vue";
import Preloader from "~/components/page/Preloader.vue";

const props = defineProps<{
  item: any;
}>();

const showQuestionModal = ref(false);
const question = ref("");
const questionError = ref("");
const isQuestionSaving = ref(false);
const isQuestionSent = ref(false);

const openQuestionModal = () => {
  showQuestionModal.value = true;
};

const saveQuestion = async () => {
    questionError.value = "";
  question.value = question.value.trim();
  if (!question.value.length) {
    questionError.value = "Введите вопрос";
    return;
  }

  if (question.value.length > 1000) {
    questionError.value = "Вопрос не должен превышать 1000 символов";
    return;
  }

  const url = "lot-questions/create";

  const data = {
    lotId: props.item.id,
    text: question.value,
  };

  const apiRequest = new ApiRequest("post", url, null, data);
  isQuestionSaving.value = true;

  try {
    const response = await apiRequest.request();

    if (!response) {
        questionError.value = "Произошла ошибка при отправке вопроса";
        isQuestionSaving.value = false;
        return;
    }

    isQuestionSent.value = true;
    isQuestionSaving.value = false;
    question.value = "";
    questionError.value = "";
  } catch (error) {
    questionError.value = "Произошла ошибка при отправке вопроса";
    isQuestionSaving.value = false;
    return;
  }

};

const onModalClose = () => {
    showQuestionModal.value = false;
  setTimeout(() => {
    isQuestionSent.value = false;
    question.value = "";
    questionError.value = "";
  }, 1000);
};
</script>

<style scoped>
button {
  cursor: pointer;
}

.question-textarea {
  margin: 25px 0 55px;

  textarea {
    word-break: break-word;
  }
}

.question-length {
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-top: 2px;
}
</style>